<div mat-dialog-content id="apiErrorDialog">
  <div class="content-popup">
    <div class="modal-body">
      <p class="white-spaced">
        {{ errMsg }}
      </p>
    </div>
    <div class="filter-modal-footer">
      <button
        type="button"
        class="btn btn-lg btn-primary"
        data-dismiss="modal"
        (click)="closeSession()"
      >
        {{ "SessionTimeOut.ok" | translate }}
      </button>
    </div>
  </div>
</div>
